// Naming rules for units, product types and buildings. Each function mirrors
// the SQL in supabase/migrations/20261104120000_naming_rules.sql exactly, so a
// form can show and pre-check what the database will store and enforce.

/** Trim, turn whitespace runs into "-", collapse repeated "-".
 *  "H3-6 - 3BP Brick" -> "H3-6-3BP-Brick". SQL: normalize_apartment_number(). */
export function normalizeApartmentNumber(value: string): string {
  return value.trim().replace(/\s+/g, "-").replace(/-{2,}/g, "-");
}

/** Comparison key for apartment numbers: unique per organization ignoring case. */
export function apartmentNumberKey(value: string): string {
  return normalizeApartmentNumber(value).toLowerCase();
}

/** Stored form of a product type name: trimmed, lower case, single spaces. */
export function normalizeProductName(value: string): string {
  return value.trim().replace(/\s+/g, " ").toLowerCase();
}

/** Duplicate key for product types: lower case with all spaces removed, so
 *  "Chei Chei" and "CheiChei" are the same product. */
export function productKey(value: string): string {
  return value.replace(/\s/g, "").toLowerCase();
}

/** Duplicate key for building names: trimmed, ignoring case. */
export function buildingKey(value: string): string {
  return value.trim().toLowerCase();
}
